import Modal from 'bootstrap/js/src/modal.js';

class DynamicModal {
  constructor(anchorElement, options = {}) {
    this.anchorElement = anchorElement;
    this.id = this.generateRandomId();

    const defaults = {
      'title': '',
    };

    this.options = Object.assign({}, defaults, options);

    this.addModalToDom();
    this.registerEventListener();
  }

  registerEventListener() {
    this.anchorElement.addEventListener('click', (event) => {
      event.preventDefault();

      const url = this.anchorElement.href;
      
      this.fetchModalContent(url);
    });
  }

  fetchModalContent(url) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        document.querySelector(`#${this.id} .modal-body`).innerHTML = html;
        this.modal.show();
      })
      .catch((error) => {
        console.error('Failed to load modal content from URL:', error);
      });
  }

  addModalToDom() {
    document.body.insertAdjacentHTML('beforeEnd', `
      <div id="${this.id}" class="modal" tabindex="-1" aria-labelledby="${this.id}-heading" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h2 id="${this.id}-heading" class="visually-hidden">${this.options.title}</h2>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    `);

    this.initializeModal();
    this.registerModalEventListener();
  }

  registerModalEventListener() {
    document.querySelector(`#${this.id}`).addEventListener('hidden.bs.modal', () => {
      this.anchorElement.focus();
    });
  }

  initializeModal() {
    this.modal = new Modal(document.querySelector(`#${this.id}`));
  }

  generateRandomId() {
    const letters = 'abcdefghijklmnopqrstuvwxyz';
    const randomLetter = letters.charAt(Math.floor(Math.random() * letters.length));
    return randomLetter + (Math.random() + 1).toString(36).substring(2);
  }
}

export default DynamicModal;
